import React from 'react';
import './ReconnectionMessage.css';
export const ReconnectionMessage = ({ isReconnecting }: { isReconnecting?: boolean }) => {
  return (
    <div className={'reconnection_message-reconnecting'} style={{ top: isReconnecting ? 0 : -30 }}>
      {isReconnecting ? 'Reconnecting...' : 'Connected!'}
    </div>
  );
};
